import { render, staticRenderFns } from "./input-switch.vue?vue&type=template&id=e149c48c&scoped=true"
import script from "./input-switch.ts?vue&type=script&lang=ts&external"
export * from "./input-switch.ts?vue&type=script&lang=ts&external"
import style0 from "./input-switch.vue?vue&type=style&index=0&id=e149c48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e149c48c",
  null
  
)

export default component.exports